import { makeVar } from '@apollo/client'

export const condensedEventCardsVar = makeVar(false)

export const resetCondensedEventCardsVar = () => {
  condensedEventCardsVar(false)
}
